import { render } from "./SubscriptionsArchive.vue?vue&type=template&id=2e19ae29&scoped=true"
import script from "./SubscriptionsArchive.vue?vue&type=script&lang=js"
export * from "./SubscriptionsArchive.vue?vue&type=script&lang=js"

import "./SubscriptionsArchive.vue?vue&type=style&index=0&id=2e19ae29&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e19ae29"]])

export default __exports__